import { render } from "./Chains.vue?vue&type=template&id=48403984&scoped=true"
import script from "./Chains.vue?vue&type=script&lang=js"
export * from "./Chains.vue?vue&type=script&lang=js"

import "./Chains.vue?vue&type=style&index=0&id=48403984&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48403984"]])

export default __exports__